
















































import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

import { WithAppContext } from '@/mixins';

import AddToCartButton from '@/components/AddToCartButton.vue';
import BottomPanel from '@/components/BottomPanel.vue';
import BuyNowButton from '@/components/BuyNowButton.vue';

import BuyboxFeatureComponent from './BuyboxFeatureComponent';

@Component({
  components: {
    AddToCartButton,
    BottomPanel,
    BuyNowButton,
  },
  props: {
    quantity: {
      type: Number,
      required: true,
    },
  },
})
export default class BuyboxBottomPanelFeature extends mixins(BuyboxFeatureComponent, WithAppContext) { }

